import clsx from 'clsx';

import { Chip, Icon } from '@atom/mui';
import { type IconComponent } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { stripWhiteSpace } from '@atom/utilities/stringUtilities';

import classes from './tab.module.css';

export interface Tab {
  icon?: IconComponent;
  label: string;
  value: any;
  showCount?: boolean;
}

interface Props {
  activeView: any;
  setActiveView: (view: any) => void;
  count?: number;
  tab: Tab;
}

const styles = {
  chip: {
    marginTop: '5px',
    marginRight: '5px',
    backgroundColor: colors.utility.highlight,
    borderRadius: '20px',
  },
  icon: {
    marginRight: '0.25rem',
  },
};

const ChipTab = ({ activeView, setActiveView, count, tab }: Props) => {
  const isActive = activeView === tab.value;
  const iconColor = isActive ? colors.brand.blue : colors.neutral.gray;
  const label = (
    <div className={clsx(classes.tab, isActive && classes.active)}>
      {tab.icon && (
        <Icon color={iconColor} style={styles.icon} icon={tab.icon} />
      )}
      {tab.label}
      {tab.showCount && count > 0 && (
        <div className={classes.tabCount}>{count}</div>
      )}
    </div>
  );
  const chipStyle = {
    background: isActive
      ? colors.utility.lightBlueHighlight
      : colors.utility.highlight,
    ...styles.chip,
  };

  return (
    <Chip
      color={isActive ? 'primary' : 'default'}
      key={tab.value}
      label={label}
      onClick={() => setActiveView(tab.value)}
      style={chipStyle}
      data-cy={`tab-${stripWhiteSpace(tab.label)}`}
    />
  );
};

export default ChipTab;
